import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

export enum SavingsGoalLayout {
  Chart = 1,
  ProgressBar = 2
}

export const savingsGoalLayoutOptions = mapEnumToOptions(SavingsGoalLayout, 'SavingsGoalLayout');
